import {
  LOGIN_FLOW,
  LOGIN_SUCCESS
} from '../../consts/localStorage';
import { loginFlowMap } from '../../consts/login';
import { LoginType } from '../../types/login';
import {
  AnalyticEventsMap,
  AnalyticsEvents
} from '../analytics';

export const setLoginType = (loginType: LoginType) => {
  localStorage.setItem(LOGIN_FLOW, loginType);
};

export const processLoginAnalytics = () => {
  const loginSuccess = localStorage.getItem(LOGIN_SUCCESS);

  if (loginSuccess) {
    const loginFlowFromStorage = localStorage.getItem(
      LOGIN_FLOW
    ) as LoginType;

    if (loginFlowFromStorage) {
      AnalyticEventsMap[AnalyticsEvents.loginSuccessful](
        loginFlowMap[loginFlowFromStorage]
      );

      localStorage.removeItem(LOGIN_FLOW);
    }

    localStorage.removeItem(LOGIN_SUCCESS);
  }
};
